import { useState, useRef } from 'react';

import { getContextCoords } from '@helpers/utils';

import { contextModalWidth } from '@components/context-modal';

const useContextModal = ({
  defaultTargetRef,
  defaultPositionX = 0,
  defaultPositionY = 0,
  defaultPositionArrow = 0,
  defaultPositionArrowY = 0,
  defaultShowContextMenu = false,
  leftAlign = false,
  overflowWrap = 'anywhere'
} = {}) => {
  const targetRef = defaultTargetRef || useRef();
  const [positionX, setPositionX] = useState(defaultPositionX);
  const [positionY, setPositionY] = useState(defaultPositionY);
  const [positionArrow, setPositionArrow] = useState(defaultPositionArrow);
  const [positionArrowY, setPositionArrowY] = useState(defaultPositionArrowY);
  const [showContextMenu, setContextMenu] = useState(defaultShowContextMenu);
  const [targetHeight, setTargetHeight] = useState('100%');

  const showContextModal = () => {
    if (targetRef.current) {
      const { posX, posY, posArrow, posArrowY, height } = getContextCoords(
        targetRef.current.getBoundingClientRect(),
        contextModalWidth,
        leftAlign
      );

      setPositionY(posY);
      setPositionX(posX);
      setPositionArrow(posArrow);
      setPositionArrowY(posArrowY);
      setContextMenu(!showContextMenu);
      setTargetHeight(height)
    }

    return null;
  };

  const closeContextMenu = () => setContextMenu(false);

  return {
    showContextModal,
    contentModalProps: {
      show: showContextMenu,
      positionArrow,
      positionArrowY,
      positionX,
      positionY,
      leftAlign,
      targetHeight,
      overflowWrap
    },
    closeContextMenu,
    targetRef
  };
};

export default useContextModal;



// WEBPACK FOOTER //
// ./helpers/hooks/use-context-modal.js